var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "bar", rawName: "v-bar" }],
      staticClass: "page-content",
      style: { backgroundColor: _vm.bodyColor }
    },
    [
      _c(
        "div",
        { staticClass: "scroll-content" },
        [
          _c(
            "el-main",
            [
              _vm._t("default", [
                _vm._v("\n                content...\n            ")
              ])
            ],
            2
          ),
          _vm.showBottomLogo
            ? _c(
                "div",
                { staticClass: "buttom-logo" },
                [
                  _c("nuxt-link", {
                    staticClass: "logo-link",
                    attrs: { to: "#" }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcd3870a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcd3870a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/con-box/src/main.vue
// module id = jFpd
// module chunks = 28